import { render, staticRenderFns } from "./RefundRejectComment.vue?vue&type=template&id=799ad6c2&"
import script from "./RefundRejectComment.vue?vue&type=script&lang=js&"
export * from "./RefundRejectComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports